import { render, staticRenderFns } from "./yyTitle.vue?vue&type=template&id=d1325f6c&scoped=true"
import script from "./yyTitle.vue?vue&type=script&lang=js"
export * from "./yyTitle.vue?vue&type=script&lang=js"
import style0 from "./yyTitle.vue?vue&type=style&index=0&id=d1325f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1325f6c",
  null
  
)

export default component.exports